import { Modal } from '@fluentui/react';
import {
  SaveProjectModalContent,
  SaveProjectModalHeader,
  modalStyles,
} from './styles';
import { useContext, useState } from 'react';
import { callFunction } from '../../../../lib/Helpers';
import { X } from '@phosphor-icons/react';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { TeamsFxContext } from '../../../../Context';
import { useStore } from '../../../../store';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

interface SaveProjectModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

export const SaveProjectModal = ({
  isOpen,
  closeModal,
}: SaveProjectModalProps) => {
  const appInsights = useAppInsightsContext();
  const teamsUserCredential = useContext(TeamsFxContext).teamsUserCredential;

  const { blocks, setIsLoading, setProjectInfo } = useStore();

  const { t } = useTranslation('myapps');

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  function saveProjectAs(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setIsLoading(true);

    const params = {
      appId: '798cf522-7099-4391-b739-60e013002413',
      name,
      description,
      data: blocks,
    };

    callFunction(
      true,
      'putProject?{0}',
      JSON.stringify(params),
      false,
      teamsUserCredential
    )
      .then((data) => {
        setProjectInfo({
          id: data.id,
          name: data.name,
          description: data.description,
        });
        toast.success(t('TTS_SAVE_PROJECT_MODAL_SUCCESS'));
      })
      .catch((error) => {
        if (process.env.REACT_APP_APP_INSIGHTS !== '')
          appInsights.trackException({
            exception: error,
            properties: { component: 'TtsApp', location: 'onSaveAsProject' },
          });
        toast.error(t('TTS_SAVE_PROJECT_MODAL_FAILED'));
      })
      .finally(() => {
        closeModal();
        setIsLoading(false);
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={closeModal}
      isBlocking={false}
      containerClassName={modalStyles.container}
    >
      <SaveProjectModalContent>
        <SaveProjectModalHeader>
          <h1>{t('TTS_SAVE_PROJECT_MODAL_TITLE')}</h1>
          <h2>{t('TTS_SAVE_PROJECT_MODAL_SUBTITLE')}</h2>
          <X className="closeModal" size={24} onClick={closeModal} />
        </SaveProjectModalHeader>

        <form onSubmit={saveProjectAs}>
          <label htmlFor="projectName">
            {t('TTS_SAVE_PROJECT_MODAL_PROJECT_NAME_LABEL')}
          </label>
          <input
            type="text"
            id="projectName"
            name="projectName"
            onChange={(e) => setName(e.target.value)}
            required
          />

          <label htmlFor="projectName">
            {t('TTS_SAVE_PROJECT_MODAL_PROJECT_DESCRIPTION_LABEL')}
          </label>
          <input
            type="text"
            id="projectDesc"
            name="projectDesc"
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          <button type="submit" id="saveProjectButton">
            {t('TTS_SAVE_PROJECT_MODAL_SAVE_BUTTON')}
          </button>
        </form>
      </SaveProjectModalContent>
    </Modal>
  );
};
